<template>
  <div class="px-md-3">
    <div class="mt-md-4">
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-info-circle mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Información Adicional
        </div>
      </div>
      <div class="ml-4">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <span class="data-title">Región:</span>
            <p>{{ data.region | empty }}</p>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <span class="data-title">Municipio:</span>
            <p>{{ data.municipality | empty }}</p>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <span class="data-title">Escuela:</span>
            <p>{{ data.school | empty }}</p>
          </div>
          <div v-if="data.services" class="col-lg-4 col-md-6 col-12">
            <span class="data-title">Servicio(s):</span>
            <p>{{ data.services | empty }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="my-3">
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-calendar-days mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Información de Fechas de Proceso
        </div>
      </div>
      <div class="ml-4">
        <div class="row">
          <div class="col-md-3 col-12">
            <span class="data-title">Fecha de Solicitud:</span>
            <p>
              {{ data.requestDate | date | empty }}
            </p>
          </div>
          <div class="col-md-3 col-12">
            <span class="data-title">Fecha de Citas:</span>
            <p>{{ appointmentDates.join(', ') | empty }}</p>
          </div>
          <div class="col-md-3 col-12">
            <span class="data-title">Fecha de Evaluación:</span>
            <p>
              {{ data.evaluationDate | date | empty }}
            </p>
          </div>
          <div class="col-md-3 col-12">
            <span class="data-title">Fecha de Envío Discusión:</span>
            <p>
              {{ data.sentToDiscussionDate | date | empty }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showOfficialInfo" class="my-3">
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-user-circle mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Información de Funcionario
        </div>
      </div>
      <div class="ml-4">
        <div class="row">
          <div class="col-md-3 col-12">
            <span class="data-title">Nombre:</span>
            <p>{{ data.userName | empty }}</p>
          </div>
          <div class="col-md-3 col-12">
            <span class="data-title">Teléfono:</span>
            <p>{{ data.phone | phone | empty }}</p>
          </div>
          <div class="col-md-3 col-12">
            <span class="data-title">Correo Electrónico:</span>
            <p>
              {{ data.email | empty }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="my-3">
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-circle-right mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Información de Estatus
        </div>
      </div>
      <div class="ml-4">
        <div class="row">
          <div class="col-md-3 col-12">
            <span class="data-title">Fecha de Estatus:</span>
            <p>{{ data.status?.date | date | empty }}</p>
          </div>
          <div class="col-md-3 col-12">
            <span class="data-title">Razón de Estatus:</span>
            <p>{{ data.status?.reason | empty }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="my-3">
      <div class="d-flex align-items-center mb-2">
        <i class="fas fa-circle-user mr-2 text-orange"></i>
        <div class="color-gray-7 font-16 font-weight-bold">
          Información del Estudiante
        </div>
      </div>
      <div class="ml-4">
        <span class="data-title">Estatus del Estudiante:</span>
        <p>{{ data.studentStatus | empty }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/services/api/requisitionmanagment.api';
import peiAtReferralType from '@/utils/constants/peiAtReferralType';
import moment from 'moment';
export default {
  name: 'AdditionalInformation',
  components: {},
  props: {
    item: {
      type: Object,
      required: true,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return { data: {}, appointmentDates: [] };
  },
  computed: {
    showOfficialInfo() {
      return ![
        peiAtReferralType.EquipmentRelatedServiceRequest,
        peiAtReferralType.TechnicalAssistanceServiceRequest,
      ].includes(this.item.referralTypeId);
    },
  },

  async mounted() {
    const { data } = await apiService.getAdditionalInfo(this.item.id);
    this.data = data;
    data.appointmentDates.forEach((element) => {
      this.appointmentDates.push(
        moment(element)
          .locale('es')
          .format('DD/MMM/YYYY')
      );
    });
  },
  methods: {},
};
</script>

<style></style>
